import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _OuterBoxBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 卡片盒子的主体的宽度 */
  '--outer-box-main-width'?: string
  /** 卡片盒子主体的高度 */
  '--outer-box-main-height'?: string
}
